<template>
  <EditorPopover ref="popover" @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-skew">
          <i class="far fa-square icon-skew-qtr"></i> Skew Tool
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-skew">
          <div class="row form-group" v-show="skewAvailable">
            <label class="col-form-label col-4">Current Diagonal</label>
            <div class="col-8">
              <FormStaticLabel>{{formatDecimal(lineLength, 2)}}mm</FormStaticLabel>
            </div>
          </div>
          
          <div class="row form-group" v-show="skewAvailable">
            <label class="col-form-label col-4">Required Diagonal</label>
            <div class="col-8">
              <FormInputText v-model="requiredDiagonalLength" addon="mm" />
            </div>
          </div>
          
          <EditorPopoverNotification :text="errorText" />

          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton title="Reset" type="action" icon="fa-repeat" :disabled="!skewAvailable" @click="popoverActionButtonClick('reset')" />
            <EditorPopoverButton title="Apply Skew" type="update" icon="fa-check" :disabled="!skewAvailable" @click="popoverActionButtonClick('applySkew', { requiredDiagonalLength: requiredDiagonalLength })" />
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>
    
  </EditorPopover>
</template>



<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorPopoverDataRow from '@glass-designer/components/editorPopoverDataRow'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'
import EditorPopoverNotification from '@glass-designer/components/editorPopoverNotification'

import { LibraryItemShapeTypes } from '@glass-designer/types'

export default {
  name: 'EditorSkewToolPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorPopoverDataRow,
    EditorPopoverButtonList,
    EditorPopoverButton,
    EditorPopoverNotification
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      toolInfoText: '',
      name: '',
      lineLength: 0,
      errorText: '',
      requiredDiagonalLength: 0,
      skewAvailable: false
    }
  },
  computed: {
  },
  watch: {
    requiredDiagonalLength: function() {
      this.debouncedUpdateTool()
    }    
  },
  created() {
    this.debouncedUpdateTool = _.debounce(this._updateTool, 100)

  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      this.errorText = ''

      this.name = options.name || 'Skew Tool'
      let skewData = options.skewData || {}
      this.lineLength = skewData.lineLength || 0
      this.requiredDiagonalLength = skewData.requiredDiagonalLength || 0
      this.addDatumAvailable = skewData.addDatumAvailable
      this.skewAvailable = skewData.skewAvailable

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.actionCallback = options.actionCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.itemData = null

      this.callbackContext = null
      this.updateCallback = null
      this.actionCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    _updateTool() {
      this.updateTool({ apply: false })
    },
    updateTool(options = {}) {
      try {
        this.updateErrorText('')

        if(options.apply) {
          if(this.applyCallback) {
            this.applyCallback(this.callbackContext, {
              actionTag: options.actionTag,
              requiredDiagonalLength: this.parseToolNumber(this.requiredDiagonalLength)
            })
            this.hide()
          }
        } else {
          if(this.updateCallback) {
            this.updateCallback(this.callbackContext, {
              requiredDiagonalLength: this.parseToolNumber(this.requiredDiagonalLength)
            })
          }
        }

      } catch(err) {
        console.error(err)
      }
    },
    updateErrorText(text) {
      this.errorText = text
    }
  }
}
</script>